(function ($) {
  $(document).ready(function() {
    // Function to add or remove the class based on scroll position
    function toggleStickyHeader() {
      var scrollPosition = $(window).scrollTop();
      var headerHeight = $('.content-detail--menu-cover').outerHeight();

      if (scrollPosition > headerHeight) {
        $('.content-detail--menu-cover').addClass('sticky');
        
      } else {
        $('.content-detail--menu-cover').removeClass('sticky');

      }
    }
  
    // Initial call to set the class based on initial scroll position
    toggleStickyHeader();
  
    // Call toggleStickyHeader on scroll
    $(window).on('scroll', function () {
      toggleStickyHeader();
    });
  
    // Smooth scroll functionality
    $('.content-detail--menu a[href^="#"]').on('click', function(e) {
      e.preventDefault();
      var target = $(this).attr('href');
      $('html, body').animate({
        scrollTop: $(target).offset().top - 60
      }, 'slow');
    });

    // Smooth scroll functionality for URL with ID on page load
    if (window.location.hash) {
      var target = window.location.hash;
      $('html, body').animate({
        scrollTop: $(target).offset().top - 60
     }, 'slow');
    }
    
  });
})(jQuery);


